import { createAsyncThunk } from '@reduxjs/toolkit';
import RootState from "../states/root.state";
import { getMyPromos, getPromos, getPromoById, createPromoApi, updatePromoApi, deletePromoApi } from '../../services/api/promos.api';

export const fetchMyPromos = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
  'promos/my',
  async (params, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        const response = await getMyPromos(token, params);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while fetching promos.");
        } else {
            return rejectWithValue('An error occurred while fetching promos.');
        }
    }
  }
);

export const fetchPromoById = createAsyncThunk<any, number, { rejectValue: string; state: RootState}>(
  'promos/show',
  async (id, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        const response = await getPromoById(token, id);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while fetching promo.");
        } else {
            return rejectWithValue('An error occurred while fetching promo.');
        }
    }
  }
);

export const fetchPromos = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
  'promos/list',
  async (params, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        const response = await getPromos(token, params);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while fetching promos.");
        } else {
            return rejectWithValue('An error occurred while fetching promos.');
        }
    }
  }
);

export const createPromo = createAsyncThunk<any, {
  title: string,
  body: string,
  image_key?: string | null,
  url?: string | null,
  button_label?: string | null,
  start_date?: string | null,
  end_date?: string | null,
  frequency?: number | null,
  dealer_ids: number[],
  is_draft: boolean | null
}, { rejectValue: string; state: RootState}>(
  'promos/create',
  async (promoInfo, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        const response = await createPromoApi(token, promoInfo);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while creating promo.");
        } else {
            return rejectWithValue('An error occurred while creating promo.');
        }
    }
  }
);

export const updatePromo = createAsyncThunk<any, {id: number, data: any}, { rejectValue: string; state: RootState}>(
  'promos/update',
  async ({id, data}, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        const response = await updatePromoApi(token, id, data);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while updating promo.");
        } else {
            return rejectWithValue('An error occurred while updating promo.');
        }
    }
  }
);

export const deletePromo = createAsyncThunk<any, number, { rejectValue: string; state: RootState}>(
  'promos/delete',
  async (id, {rejectWithValue, getState}) => {
    try {
        const {user} = getState();
        const token = user.accessToken;
        await deletePromoApi(token, id);
        return id;
    } catch (error: any) {
        if (error.response) {
            return rejectWithValue(error.response.data?.data?.message??error.response.data?.message??"An error occurred while deleting promo.");
        } else {
            return rejectWithValue('An error occurred while deleting promo.');
        }
    }
  }
);

